<template>
	<div>
		<el-dialog
			:visible.sync="visibleDialog"
			:fullscreen="fullscreen"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:append-to-body="true"
			:custom-class="customClass"
			v-bind="$attrs"
			v-on="$listeners"
		>
			<template #title>
				<slot name="title">
					<h3 class="text-lg">{{ title }}</h3>
					<div v-if="isFullscreen" class="el-dialog__headerbtn" style="right: 60px">
						<i
							:class="fullscreen ? 'el-icon-bottom-left opacity-50' : 'el-icon-full-screen'"
							@click="fullscreen = !fullscreen"
						></i>
					</div>
				</slot>
			</template>

			<!--内容区域插槽-->
			<slot name="content"></slot>

			<template #footer>
				<!--对外暴漏footer插槽，个别按钮进行自定义-->
				<slot v-if="showBtn" name="footer">
					<!--默认集成确定与取消按钮-->
					<el-button @click="$handleCancel">取 消</el-button>
					<el-button type="primary" @click="$handleConfirm">确 定</el-button>
				</slot>
			</template>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'JrDialog',
		props: {
			// 弹窗标题
			title: {
				type: String,
				default: 'dialog窗口'
			},
			// 对外暴漏visible属性，用于显示于隐藏
			visible: {
				type: Boolean,
				default: false
			},
			// 是否全屏打开
			isFullscreen: {
				type: Boolean,
				default: false
			},
			// 内置按钮大小
			size: {
				type: String,
				default: 'small'
			},
			showBtn: {
				type: Boolean,
				default: true
			},
			customClass: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				fullscreen: false
			}
		},
		computed: {
			visibleDialog: {
				get() {
					return this.visible
				},
				set(val) {
					this.$emit('update:visible', val)
				}
			}
		},
		created() {},
		mounted() {},
		methods: {
			// 对外抛出cancle事件
			$handleCancel() {
				this.$emit('cancel')
			},
			// 对外抛出confirm事件
			$handleConfirm() {
				this.$emit('confirm')
			}
		}
	}
</script>

<style lang="scss">
	.el-dialog__header {
		padding: 0px 20px;
		background-color: #ffffff;

		h3 {
			font-size: 22px;
			line-height: 3;
			font-weight: 500;
			color: #333333;
			text-align: center;
		}
	}

	.el-dialog__headerbtn {
		top: -15px;
		right: -15px;
		background-color: #4686b2;
		width: 30px;
		height: 30px;
		border-radius: 15px;

		.el-dialog__close {
			color: #ffffff;
		}
	}

	.el-dialog__body {
		padding: 10px 20px;
		color: #606266;
	}

	.el-dialog {
		// position: absolute;
		// top: 50%;
		// left: 50%;
		// margin: 0 !important;
		// transform: translate(-50%, -50%);
		// max-height: calc(100% - 30px);
		// max-width: calc(100% - 30px);
		display: flex;
		flex-direction: column;
		box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
		margin-bottom: 0;
		max-height: 80vh;
	}

	.el-dialog__body {
		flex: 1;
		overflow: auto;
	}

	.el-dialog__footer {
		text-align: center;
	}
</style>
